var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pa-3 pa-sm-4 pa-md-2"},[(_vm.classData)?_c('Breadcrumbs',{attrs:{"data":"classData.title","headline":((_vm.classData.title) + " (" + (_vm.classData.code) + ")"),"link":[
        { text: 'Lớp học', href: '../../../classes' },
        {
          text: ((_vm.classData.title) + " (" + (_vm.classData.code) + ")"),
          id: _vm.classData.id,
          href: ("../../class/" + (_vm.classData.id))
        },
        { text: 'Sổ Điểm' }
      ]}}):_vm._e()],1),_c('v-card',{staticClass:"mt-3 mx-md-2 px-3",attrs:{"elevation":"1"}},[(!_vm.slots)?_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"300","type":"table-heading"}}):_c('marks',{attrs:{"classData":_vm.classData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }